import React from "react";
import Partners from "./Partners";

export default function Footer() {
  return (
    <footer className="ud-footer wow fadeInUp" data-wow-delay=".15s">
      <div className="shape shape-1">
        <img src="/assets/images/footer/shape-1.svg" alt="shape" />
      </div>
      <div className="shape shape-2">
        <img src="/assets/images/footer/shape-2.svg" alt="shape" />
      </div>
      <div className="shape shape-3">
        <img src="/assets/images/footer/shape-3.svg" alt="shape" />
      </div>

      <div className="ud-footer-widgets">
        <div className="container">
          <div className="row">
            {/* Hakkımızda */}
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="ud-widget">
                <a href="/" className="ud-footer-logo">
                  <span className="fw-bold text-white aidat-logo">Aidat+</span>
                </a>
                <p className="ud-widget-desc">
                  Aidat+, site ve apartman yönetimi için modern bir platform
                  sunar. Kullanıcı yönetimi, aidat ve ödeme takibini tek
                  panelden yapabilirsiniz.
                </p>
                <ul className="ud-widget-socials">
                  <li>
                    <a
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-facebook-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-twitter-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-instagram-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-linkedin-original"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Yardım / Hızlı Linkler */}
            <div className="ms-auto col-xl-2 col-lg-2 col-md-6 col-sm-6">
              <div className="ud-widget">
                <h5 className="ud-widget-title">Hızlı Linkler</h5>
                <ul className="ud-widget-links">
                  <li>
                    <a href="/dashboard">Dashboard</a>
                  </li>
                  <li>
                    <a href="/sites">Siteler</a>
                  </li>
                  <li>
                    <a href="/apartments">Daireler</a>
                  </li>
                  <li>
                    <a href="/payments">Ödemeler</a>
                  </li>
                  <li>
                    <a href="/announcements">Duyurular</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Özellikler */}
            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
              <div className="ud-widget">
                <h5 className="ud-widget-title">Özellikler</h5>
                <ul className="ud-widget-links">
                  <li>
                    <a href="/features#user-management">Kullanıcı Yönetimi</a>
                  </li>
                  <li>
                    <a href="/features#payment-tracking">
                      Aidat / Ödeme Takibi
                    </a>
                  </li>
                  <li>
                    <a href="/features#notifications">
                      Duyurular & Bildirimler
                    </a>
                  </li>
                  <li>
                    <a href="/features#reports">Raporlar</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Ürünler */}
            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
              <div className="ud-widget">
                <h5 className="ud-widget-title">Destek</h5>
                <ul className="ud-widget-links">
                  <li>
                    <a href="/pricing">Fiyatlandırma</a>
                  </li>
                  <li>
                    <a href="/docs">Dokümantasyon</a>
                  </li>
                  <li>
                    <a href="/faq">SSS</a>
                  </li>
                  <li>
                    <a href="/support">Destek</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer alt */}
      <div className="ud-footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <span className="text-white" style={{ marginRight: 8 }}>
                Aidat+
              </span>
              <ul className="ud-footer-bottom-left">
                {/* <li>
                  <a href="/privacy-policy">Gizlilik Politikası</a>
                </li>
                <li>
                  <a href="/support-policy">Destek Politikası</a>
                </li>
                <li>
                  <a href="/terms">Kullanım Şartları</a>
                </li> */}
              </ul>
            </div>
            <div className="col-md-4">
              <p className="ud-footer-bottom-right">
                {new Date().getFullYear()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
